import { FcGoogle } from 'react-icons/fc';

import type { IconComponentType } from '@/utils/types';

type ProviderConfig = {
  Icon?: IconComponentType;
  displayName: string;
};

export const SSO_PROVIDER_CONFIG = {
  google: {
    Icon: FcGoogle,
    displayName: 'Google',
  },
} as const satisfies Record<string, ProviderConfig>;

export function getProviderConfig(providerId: string): ProviderConfig {
  const lowerProviderId = providerId.toLowerCase();

  if (lowerProviderId in SSO_PROVIDER_CONFIG) {
    return SSO_PROVIDER_CONFIG[lowerProviderId as keyof typeof SSO_PROVIDER_CONFIG];
  }

  for (const [key, config] of Object.entries(SSO_PROVIDER_CONFIG)) {
    if (lowerProviderId.includes(key)) {
      return config;
    }
  }

  return {
    displayName: providerId,
  };
}
